<script setup lang="ts">
import type { LocationApiSearchResult } from '@@/shared/location/types';
import type { IadAppRoute } from '~/application';

defineProps<{
  placeholder?: string
}>();

const localePath = useLocalePath();
const { locale } = useI18n();
async function onSectorSelection(location?: LocationApiSearchResult) {
  if (!location) return;
  trackEvent({
    event: 'search',
    event_name: 'search_interaction',
    search_location: 'search_page',
    search_type: 'collaborator',
    search_term: location.displayNameWithCode,
  });
  const sectorUrl: IadAppRoute<`find-real-estate-agent-agentSector`> = {
    name: `find-real-estate-agent-agentSector`,
    params: { agentSector: location.slug },
  };

  const path = localePath(sectorUrl, locale.value);
  await navigateTo({ path });
}
</script>

<template>
  <IadInputLocation
    class="flex-1"
    :placeholder
    @update:model-value="onSectorSelection"
  />
</template>
